"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const App_1 = require("./App");
require("./app.less");
const LoggerHelper_1 = require("./helpers/LoggerHelper");
const UrlHelper_1 = require("./helpers/UrlHelper");
const SharedTypes_1 = require("./models/SharedTypes");
const container = document.getElementById('launcherApp');
const language = document.getElementsByTagName('html')[0].lang;
const basePath = container.getAttribute('basePath');
const injectedEntryPoint = container.getAttribute('entryPoint');
const injectedSkypetoken = container.getAttribute('skypetoken');
const entryPoint = (injectedEntryPoint && injectedEntryPoint !== '{ENTRYPOINT}') ? injectedEntryPoint : App_1.EntryPoint.Meetings;
const skypetoken = (injectedSkypetoken && injectedSkypetoken !== '{SKYPETOKEN}') ? injectedSkypetoken : undefined;
const rawTheme = UrlHelper_1.UrlHelper.getQueryParameter('theme');
let theme;
if (Object.values(SharedTypes_1.Themes).includes(rawTheme)) {
    theme = rawTheme;
}
LoggerHelper_1.logger.init();
ReactDOM.render(React.createElement(App_1.App, { language: language, theme: theme, basePath: basePath, entryPoint: entryPoint, skypetoken: skypetoken }), container);
